import TwoCellRow from "components/TwoCellRow";
import CustomFormatNumber from "components/CustomFormatNumber";

import { PRODUCT_CATEGORIES, PRODUCT_TYPE, hasCombinedRetailClubDealTenant } from "constants/index";

import { formatNoDecimalNumber } from "utils";
import IntlFormattedMessage from "components/IntlFormattedMessage";
import NewLoader from "components/NewLoader";

const KPIBlock = ({
    formatMessage,
    messages,
    actionBox,
    lines,
    isTypeClub,
    isTypeClubButton,
    categoryProduct,
    typeProduct,
    isLoggedIn,
    userEmail,
    isUserInvestmentsLoading,
    isSingleProductLoading,
    isMobileScreen,
    actionButton,
    totalReturnEstimate,
    perAnnoReturnEstimate,
    perAnnoMortgageRepaymentEstimate,
    perAnnoPropertyValueGrowthEstimate,
    objectType,
    finalizationDate,
    isMarketplace,
    numberOfShares,
    currentTenant = "",
}) => {
    const footerNote = {
        [PRODUCT_CATEGORIES.TRANSPORTATION]: <IntlFormattedMessage id={messages.assetfooterNote} />,
        [PRODUCT_CATEGORIES.FINE_WINE]: <IntlFormattedMessage id={messages.assetfooterNote} />,
        [PRODUCT_CATEGORIES.ART]: <IntlFormattedMessage id={messages.assetfooterNote} />,
        [PRODUCT_CATEGORIES.CLASSIC_CARS]: <IntlFormattedMessage id={messages.assetfooterNote} />,
        [PRODUCT_CATEGORIES.DIAMONDS]: <IntlFormattedMessage id={messages.assetfooterNote} />,
        [PRODUCT_CATEGORIES.LUXURY_WATCHES]: <IntlFormattedMessage id={messages.assetfooterNote} />,
        [PRODUCT_CATEGORIES.PRIVATE_EQUITY]: <IntlFormattedMessage id={messages.realClubfooterNote} />, // Change privateEquityFooterNote to realClubfooterNote for ticket FRON-398,
        [PRODUCT_CATEGORIES.RESIDENTIAL]: <IntlFormattedMessage id={messages.realClubfooterNote} />,
        [PRODUCT_TYPE.CL_PUBLIC_PLACEMENT]: <IntlFormattedMessage id={messages.realClubfooterNote} />,
        [PRODUCT_TYPE.CL_DIRECT_SELECT]: <IntlFormattedMessage id={messages.realClubfooterNote} />,
    };

    const renderFooterNote = (type, category) => {
        console.log(category, type, "test");

        return footerNote[category] || footerNote[type] || formatMessage(messages.predictedTotalReturn);
    };

    const KPIBox = () => {
        return (
            <section className="flex column prepositions right-info-block register-block">
                <div className="flex column buying">
                    <div className="prices">
                        <div className="flex row justify-between discount align-center">
                            <span className="primary-color text-16">{renderFooterNote(typeProduct, categoryProduct)}</span>
                            <span className="text-display text-no-break align-baseline">
                                {totalReturnEstimate && formatNoDecimalNumber(totalReturnEstimate)}{" "}
                                {<span className="text-16 ml-2 fw-600">%</span>}
                            </span>
                        </div>
                        <div className="flex column price-info">
                            <TwoCellRow
                                lClassname="text-14 fw-400 mb-4"
                                left={formatMessage(messages.forecastDistribution)}
                                right={perAnnoReturnEstimate ? `${formatNoDecimalNumber(perAnnoReturnEstimate)} %` : ""}
                            />
                            <TwoCellRow
                                lClassname="text-14 fw-400 mb-4"
                                left={formatMessage(messages.forecastRepayment)}
                                right={
                                    perAnnoMortgageRepaymentEstimate
                                        ? `${formatNoDecimalNumber(perAnnoMortgageRepaymentEstimate)} %`
                                        : ""
                                }
                            />
                            {objectType && objectType === "Serviced Apartment" ? (
                                <></>
                            ) : (
                                <>
                                    <TwoCellRow
                                        lClassname="text-14 fw-400"
                                        left={formatMessage(messages.forecastIncrease)}
                                        right={
                                            perAnnoPropertyValueGrowthEstimate
                                                ? `${formatNoDecimalNumber(perAnnoPropertyValueGrowthEstimate)} %`
                                                : ""
                                        }
                                    />
                                </>
                            )}
                            <div className="border-x" />
                            <TwoCellRow
                                lClassname="text-14 fw-400 mb-4"
                                left={formatMessage(messages.propertyType)}
                                right={objectType}
                            />
                            {isMarketplace ? (
                                <>
                                    <TwoCellRow
                                        lClassname="text-14 fw-400 mb-4"
                                        left={formatMessage(messages.indicativeAssessment)}
                                        right={<CustomFormatNumber value={2150454} fixed={0} />}
                                    />
                                    <TwoCellRow
                                        lClassname="text-14 fw-400 mb-4"
                                        left={formatMessage(messages.currentPurchasePrice)}
                                        right={<CustomFormatNumber value={1.07} />}
                                    />
                                    <TwoCellRow
                                        lClassname="text-14 fw-400 mb-4"
                                        left={formatMessage(messages.developmentSincePurchase)}
                                        right="+ 7,00 %"
                                        rClassname="primary-color"
                                    />
                                </>
                            ) : (
                                <>
                                    <TwoCellRow
                                        lClassname="text-14 fw-400 mb-4"
                                        left={formatMessage(messages.readyToMove)}
                                        right={finalizationDate}
                                    />
                                    <TwoCellRow
                                        lClassname="text-14 fw-400 mb-4"
                                        left={formatMessage(messages.financingVolume)}
                                        right={<CustomFormatNumber value={numberOfShares} fixed={0} />}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    <div className="buttons invest-btn">
                        {!isLoggedIn ? (
                            actionButton
                        ) : !isUserInvestmentsLoading && !isSingleProductLoading && userEmail ? (
                            actionButton
                        ) : (
                            <NewLoader type="primary" className="d-block mx-auto" />
                        )}
                    </div>
                </div>
            </section>
        );
    };

    const ActionBoxKPIBox = () => {
        const firstL = lines?.[0]?.left,
            fla = firstL?.split(" "),
            linesLength = lines?.length;
        let lastLines, midLines;

        if (isTypeClub) {
            lastLines = lines?.slice(linesLength - 3, linesLength);
            midLines = lines?.slice(1, linesLength - 3);
        } else {
            midLines = lines?.slice(1, 4);
            lastLines = lines?.slice(4, linesLength);
        }

        const isAssetType =
            categoryProduct &&
            (categoryProduct === PRODUCT_CATEGORIES.ART ||
                categoryProduct === PRODUCT_CATEGORIES.FINE_WINE ||
                categoryProduct === PRODUCT_CATEGORIES.CLASSIC_CARS ||
                categoryProduct === PRODUCT_CATEGORIES.DIAMONDS);

        return (
            <section className="flex column prepositions right-info-block register-block">
                <div className="flex column buying">
                    <div className="prices">
                        <div className="flex row justify-between discount align-center">
                            <span className="primary-color text-16">
                                <>
                                    {isAssetType ? `${fla?.[0]} ${fla?.[1]}` : fla?.[0]}
                                    <br />
                                    {isAssetType ? fla?.slice(2).join(" ") : fla?.slice(1).join(" ")}
                                </>
                            </span>
                            <span className="text-display text-no-break align-baseline">
                                <>
                                    {lines?.[0]?.right.substring(0, lines?.[0]?.right.length - 1)}{" "}
                                    <span className="ml-2 text-16 fw-600">%</span>
                                </>
                            </span>
                        </div>
                        <div className="flex column price-info">
                            {midLines?.map((obj, index) => {
                                if (obj.left !== "Progn. Zielfonds-Multiple") {
                                    return (
                                        <TwoCellRow
                                            key={index}
                                            renderLeft={() => (
                                                <label className="flex fw-400 mb-4">
                                                    {obj.left}
                                                    <span
                                                        data-place={isMobileScreen ? "right" : "top"}
                                                        data-tooltip-id="two-cell-row"
                                                        data-tooltip-content={obj.explanation}
                                                        className={`question ${obj.explanation === "" ? "d-none" : ""}`}
                                                    >
                                                        ?
                                                    </span>
                                                </label>
                                            )}
                                            right={obj.right}
                                            rClassname="text-right"
                                        />
                                    );
                                }
                            })}
                            <div className="border-x" />
                            {lastLines?.map((obj, index) => {
                                if (obj.left !== "Progn. Zielfonds-Multiple") {
                                    return (
                                        <TwoCellRow
                                            key={index}
                                            containerClassname="lastlines-item"
                                            renderLeft={() => (
                                                <label className="fw-400 mb-4">
                                                    {obj.left}
                                                    <span
                                                        data-place={isMobileScreen ? "right" : "top"}
                                                        data-tooltip-id="two-cell-row"
                                                        data-tooltip-content={obj.explanation}
                                                        className={`question ${obj.explanation === "" ? "d-none" : ""}`}
                                                    >
                                                        ?
                                                    </span>
                                                </label>
                                            )}
                                            rClassname={`${
                                                obj.right.startsWith("+")
                                                    ? "primary-color"
                                                    : obj.right.startsWith("-")
                                                      ? "alert-red-color"
                                                      : ""
                                            } text-right`}
                                            right={obj.right}
                                        />
                                    );
                                }
                            })}
                        </div>
                    </div>
                    <div className="buttons invest-btn">
                        {!isLoggedIn && isTypeClub && !hasCombinedRetailClubDealTenant(currentTenant) ? (
                            isTypeClubButton
                        ) : userEmail && isTypeClub && !hasCombinedRetailClubDealTenant(currentTenant) ? (
                            isTypeClubButton
                        ) : !isLoggedIn ? (
                            actionButton
                        ) : !isUserInvestmentsLoading && !isSingleProductLoading && userEmail ? (
                            actionButton
                        ) : (
                            <NewLoader type="primary" className="d-block mx-auto" />
                        )}
                    </div>
                </div>
            </section>
        );
    };

    return <>{actionBox === null ? <KPIBox /> : lines?.length && <ActionBoxKPIBox />}</>;
};

export default KPIBlock;
